export default {
  listTitle: "Páciens lista",
  viewTitle: "Páciens karton",
  createTitle: "Páciens hozzáadása",
  updateTitle: "Pácient frissítése",

  action: {
    recoveryKeyDownload: 'Regisztrációs kód letöltése',
    resetAccess: 'Jelszó visszaállítás',
    sendInvite: 'Meghívó küldése',
    deletePatient: 'Páciens törlése',
    register: 'Táv regisztráció',
    details: 'Páciens profil'
  },

  modal: {
    recoveryTitle: "Regisztrációs kódok beszerzése",
    resetAccessTitle: "Felhasználói hozzáférések visszaállítása",
    recoveryKey: "Regisztrációs kód",
    inviteTitle: "Páciensek Meghívása",
    registerTitle: "Páciensek Regisztrálása",
    registerDisclaimer: "A tesztüzem ideje alatt a rendszer automatikusan kiküld egy ideiglenes jelszót a meghívott fél e-mail címére. A tesztüzem után ez a folyamat meg fog változni.",
    invitationDisclaimer: "A tesztüzem ideje alatt a rendszer automatikusan kiküld egy ideiglenes jelszót a meghívott fél e-mail címére. A tesztüzem után ez a folyamat meg fog változni.",
  },

  infoCard: {
    statistics: 'Statisztikák',
    stockManagement: 'Készletek kezelése',
    eventManagement: 'Események kezelése',
    pendingEvents: 'Aláírandó események',
    lastVisit: 'Utolsó látogatás',
    stockLastSupplied: 'Utoljára kiadva',
    availableStock: 'Kint lévő készletek',
  },

  fields: {
    email: 'E-mail',
    name: 'Teljes név',
    phoneNo: 'Telefonszám',
    socialSecurityNo: 'TAJ szám',
    address: 'Állandó lakcím',
    temporaryAddress: "Tartózkodási hely",
    associatedDiseaseConditions: "Kapcsolódó betegségek",
    additionalDiseaseConditions: "Egyéb kapcsolódó betegség",
    birthdate: "Születési idő",
    bloodType: "Vércsoport",
    concomittantMedication: "Egyéb gyógyszerek",
    dealingPhysician: "Gondozó orvos",
    diagnosis: "Diagnózis",
    drugAllergy: "Gyógyszerérzékenység",
    factorActivities: "Hiányzó faktorok",
    factorActivity: "Hiányzó faktor",
    factorConcentrateApplied: "Gyógyszer neve",
    weight: "Testsúly",
    factorLevel: {
      label: "Faktorszint",
      hint: {
        intro: "Válassza ki a beteg faktorszint típusát:",
        unknownBaseline: `A "?" jelöli ha a faktorszint ismeretlen.`,
        equals: `Az "=" jelöli ha konkrét mért laboreredményt ad meg. Ezt csak akkor válassza, ha az érték magasabb mint a laboratórium LOQ (limit of qualification) értéke.`,
        lessThan: `A "<" jelöli ha a faktorszint a mért érték BLQ (below the limit of qualification), azaz alacsonyabb mint amit a laboreredmény pontosan meg tud állapítani.`,
      },
    },
    inhibitor: "Gátlótest",
    inhibitorUnit: "Gátlótest mennyiség",
    irregularAntibodies: "Irreguláris antitestek",
    methodOfTreatment: "Kezelés módja",
    walkingAid: "Járást segítő eszköz",
    targetJoints: "Cél izület",
    targetJointTypes: "Cél izületek",
    otherTargetJoint: "Egyéb izület",
    movementActivity: "Mozgás aktivitás szintje",
  },
}
